import toast from "react-hot-toast";
import {
  ComponentInputs,
  DocumentFileMap,
  SingleTemplate,
} from "../../../models/whatsappTemplate.model";

export const validateTemplateBeforeSending = (
  singleTemplate: SingleTemplate,
  documentFile: DocumentFileMap,
  componentInputs: ComponentInputs
) => {
  const template = singleTemplate?.template;
  const templateComponents = template?.components || [];

  // If no template selected or it's hello_world, skip validation
  if (!template || template.name === "hello_world") {
    return true;
  }

  for (const comp of templateComponents) {
    const { type, text, format } = comp;
    const upperType = type.toUpperCase();
    const paramMatches = text?.match(/{{\s*\d+\s*}}/g) || [];

    for (let i = 0; i < paramMatches.length; i++) {
      const key = `${upperType}_${i + 1}`;
      if (!componentInputs[key] || !componentInputs[key].trim()) {
        toast.error(`Please fill out all parameters for ${upperType}.`);
        return false;
      }
    }

    // Validate file uploads for headers
    if (
      upperType === "HEADER" &&
      (format === "DOCUMENT" || format === "IMAGE") &&
      (!documentFile || !documentFile[upperType])
    ) {
      toast.error(`Missing ${format.toLowerCase()} file for header.`);
      return false;
    }
  }

  return true;
};
